<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Informatie over ramen</h1>
      <p>
        Zijn uw oude ramen versleten en aan vervanging toe? Of bent u op zoek
        naar ramen voor uw nieuwe woning?
      </p>
      <p>
        Om er zeker van te zijn dat u de juiste ramen aanschaft laat u zich best
        deskundig begeleiden. Hierbij kan ramenvergelijker.be u een héél eind
        verderop helpen. Hieronder kunt u namelijk terecht voor gratis offertes
        van ramenleveranciers uit uw eigen omgeving alsook voor de inwinning van
        gratis informatie en advies. Spaar kost noch moeite en laat u hieronder
        begeleiden door ramenvergelijker.be.
      </p>

      <h2>Ramen en materialen</h2>
      <p>
        Ramen zijn een belangrijk onderdeel bij uw woning. Om voldoende zonlicht
        in uw woning te laten schijnen dient u over voldoende ramen te
        beschikken. Naast het binnenlaten van zonlicht moeten deze ramen ook
        tijdens de koudere periodes over een goede isolatie beschikken. Buiten
        zonlicht en isolatie zijn er nog tal van eigenschappen die van invloed
        zijn bij het maken van de juiste beslissing die we hieronder zullen
        bespreken.
      </p>

      <p>
        Grofweg kunnen we 3 soorten ramen onderscheiden; houten ramen, aluminium
        ramen en PVC ramen. Als u al weet welk soort ramen u wilt hebben bent u
        al een heel eind. Hieronder beschrijven we alvast de belangrijkste
        eigenschappen, voordelen en nadelen bij de 3 soorten ramen:
      </p>

      <p>
        Ramen kunnen uit verschillende materialen worden gemaakt. Elk type heeft
        zo zijn voordelen en nadelen. Zo zijn PVC ramen erg duurzaam en goedkoop
        bij aanschaf. Aluminium ramen daarentegen zijn steviger, eisen minder
        onderhoud maar zijn wel duurder bij aanschaf. Houten ramen worden
        tenslotte voornamelijk gekozen voor de mooie en warme authentieke
        “look”.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Ramen laten vervangen?',
      headDescription:
        'Wilt u graag uw ramen laten vervangen? Op Ramenvergelijker.be kunt u zich uitgebreid laten informeren en adviseren over uw nieuwe ramen!',
      path: '/informatie-over-ramen',
    }
  },
}
</script>
